<div class="modal-header blue">
  <h4 class="modal-title">
    {{ modalTitle }}
  </h4>
  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<div class="modal-body">
  <div class="fz-16">
    {{ bodyTitle }}
  </div>

  <p class="mt-2" *ngIf="bodyText">
    {{ bodyText }}
  </p>
</div>

<div class="modal-footer">
  <ng-container *ngIf="modalType === 'confirm'">
    <button class="button-outline w-100px ml-auto" (click)="close()">
      {{ text.cancelButtonText }}
    </button>
    <button class="button w-80px ml-3" ngbAutofocus (click)="save()">
      {{ text.confirmButtonText }}
    </button>
  </ng-container>

  <ng-container *ngIf="modalType === 'error'">
    <button class="button w-80px" (click)="close()">Ok</button>
  </ng-container>

  <ng-container *ngIf="modalType === 'info'">
    <button class="button w-80px" (click)="close()">Ok</button>
  </ng-container>
</div>
